/* eslint-disable import/prefer-default-export,graphql/template-strings */
import gql from 'graphql-tag';

/**
 * @description *
 * @param {*} cache - Apollo cache instance.
 * @param {*} type - Type on to fragment is defined.
 * @param {*} action - Action to do with this fragment.
 * @param {*} field - Query's render props.
 * @param {*} data - New data to update the cache.
 * @param {*} ids - Item's ids to get fragment.
 * @returns {undefined} No returns value.
 */
export function bulkUpdate(cache, type, action, field, data, ids) {
  ids.forEach(id =>
    cache.writeFragment({
      id: `${type}:${id}`,
      fragment: gql`
      fragment ${type}${action} on ${type} {
        ${field}
      }
    `,
      data,
    }),
  );
}
